import z from 'zod';

import { reportError } from '../sentry.ts';

import { BaseOptionsSchema, type FormSubmitHandler } from './types.ts';

const DataSchema = z.object({
    email: z.string().nonempty(),
});

const OptionsSchema = BaseOptionsSchema.extend({
    url: z.string().nonempty(),
});

type Data = z.infer<typeof DataSchema>;
type Options = z.infer<typeof OptionsSchema>;

async function handle(data: Data, options: Options): Promise<string> {
    const { email } = data;
    const { url, errorMessage, successMessage } = options;

    const body = new FormData();

    body.append('email', email);

    let response;
    try {
        response = await fetch(url, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: body,
        });
    } catch (cause) {
        reportError(cause, { url });

        throw new Error(errorMessage);
    }

    if (!response.ok) {
        if (response.status >= 500) {
            reportError(
                new Error(`Course lead request failed: ${response.status}`),
                {
                    url,
                    status: response.status,
                },
            );
        }

        throw new Error(errorMessage);
    }

    return successMessage;
}

export default {
    dataSchema: DataSchema,
    optionsSchema: OptionsSchema,
    handle,
} satisfies FormSubmitHandler<Data, Options>;
